module.exports = __webpack_public_path__ + "static/img/logo-login.b5eb6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-login.png
// module id = OwLT
// module chunks = 11